import ElectronicOperators from '@/views/electronic-operators/electronic-operators-list.vue'
import AddElectronicOperator from '@/views/electronic-operators/electronic-operators-new.vue'
import EditElectronicOperator from '@/views/electronic-operators/electronic-operators-edit.vue'
import { ElectronicOperatorsRouteNames } from '@/router/routes-names'

export const electronicOperatorsRoutes = [
    {
        path: '/electronic-operators/',
        name: ElectronicOperatorsRouteNames.LIST,
        component: ElectronicOperators
    },
    {
        path: '/electronic-operators/new',
        name: ElectronicOperatorsRouteNames.NEW,
        component: AddElectronicOperator
    },
    {
        path: '/electronic-operators/edit/:id',
        name: ElectronicOperatorsRouteNames.EDIT,
        component: EditElectronicOperator
    }
]
